import classNames from 'classnames';
import useApplicationData from 'src/hooks/useApplicationData';
import useMarker from 'src/hooks/useMarker';
import useUI from 'src/hooks/useUI';
import { detectAndroid, detectIOS } from 'src/utils/browserUtils';
import { IconSize } from 'src/interfaces/Icon';
import useStats from 'src/hooks/useStats';
import ActiveOverlay from '../../components/ActiveOverlay';
import BottomBarDesktop from '../BottomBarDesktop';
import BottomBarMobile from '../BottomBarMobile';
import Header from '../Header';
import MobilePlaybackControls from '../MobilePlaybackControls';
import ModalVideoData from '../ModalVideoData';
import useActiveOverlay from '../Player/hooks/useActiveOverlay';
import SettingsOverlay from '../SettingsOverlay';

import SubtitleSettingsOverlay from '../SubtitleSettingsOverlay';
import styles from './styles.module.scss';

const PlayerActiveOverlay = () => {
  const { isNotesAllowed } = useMarker();
  const { mediaTitle, mediaDescription: mediaCaption } = useApplicationData();
  const hasContentOnHeader = mediaCaption || mediaTitle || isNotesAllowed();
  const { isActiveOverlayVisible } = useActiveOverlay();
  const isMobile = detectAndroid() || detectIOS();
  const { fullscreen: isFullscreen, settingsVisible, subtitleSettingsVisible } = useUI();
  const { showStats, setHideStats } = useStats();

  return (
    <ActiveOverlay
      className={classNames({
        [styles.backgroundLinearBottom]: !hasContentOnHeader,
        [styles.backgroundFull]: isMobile,
      })}
      visible={isActiveOverlayVisible}
    >
      <Header title={mediaTitle} description={mediaCaption} />
      {showStats && <ModalVideoData onHide={setHideStats} />}
      {settingsVisible && <SettingsOverlay />}
      {subtitleSettingsVisible && <SubtitleSettingsOverlay />}
      {isMobile ? <BottomBarMobile /> : <BottomBarDesktop />}
      {isMobile && <MobilePlaybackControls size={isFullscreen ? IconSize.large : IconSize.medium} />}
    </ActiveOverlay>
  );
};

export default PlayerActiveOverlay;
